import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Paper,
  Container,
  Grid,
  Typography,
  TextField,
  Autocomplete,
  Badge,
  IconButton,
  Drawer,
  InputAdornment,
  Button,
} from "@mui/material";
import { withStyles } from "@material-ui/core/styles";
import { FcSearch } from "react-icons/fc";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom"; // missing import for useNavigate
import GSTReportsIcon from "../images/GSTImage.png"; // assuming transaction image is in assets folder
import { styles } from "../Theme/Theme";
import Header from "../CommonComps/Header";
import AutoDialogBox from "../CommonComps/AutoDialogBox";
import { userConfig } from "../config/UserConfig";
import {
  gstExportEndpoint,
  gstr1DataEndpoint,
  gstr2DataEndpoint,
  gstr3BDataEndpoint,
} from "../config";
import { checkPermissionExist } from "../utils";
import TuneIcon from "@mui/icons-material/Tune";
import SideBar from "../CommonComps/SideBar";
import moment from "moment";
import GSTTable from "./GSTTable";
import { financialYearList, financialYearMonthList } from "./Utils";
import { AiFillFileExcel, AiFillFilePdf } from "react-icons/ai";
import IconTemplate from "../CommonComps/IconTemplate";
import { themecolor } from "../Navigation";
import { userService } from "../userService";
import LoadingComponent from "../Loader";
import Reconciliation12 from "./Reconciliation1&2";
import { error } from "pdf-lib";
import { AlertBar } from "../Alert/AlertBar";
import GST3Report from "./GST3BReport";
import FilteredDate from "./FilterDates";

const Index = ({ classes }) => {
  const navigate = useNavigate();
  const currentTable =
    window.location.pathname === "/gst/gst-1"
      ? "GSTR1ReportTable"
      : window.location.pathname === "/gst/gst-2"
      ? "GSTR2ReportTable"
      : "GSTR3ReportTable";

  const reduxState = useSelector((val) => val?.rootReducer);
  const restoredSite = reduxState?.siteReducer?.site;
  const endPoints = reduxState.permissionReducer?.data;

  let financialYearMonth = reduxState?.fymReducer?.data || [];
  console.log(financialYearMonth, "xbsdg");

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const [headerConfig, setHeaderConfig] = useState([]);
  const [selectedSite, setSelectedSite] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const currentMonthIndex = new Date().getMonth();
  const [selectedMonth, setSelectedMonth] = useState({
    financialYearId: 5,
    id: "03",
    isActive: true,
    monthId: 3,
    monthValue: 12,
    name: "March",
  });
  const [selectedYear, setSelectedYear] = useState(financialYearList[0]);

  const [searchField, setSearchField] = useState(null);

  //==================Pagination====================//
  const [pageNo, setPageNo] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(15);
  const [totalPages, setTotalPages] = React.useState(1);
  const [GSTData, setGSTData] = React.useState(null);
  const [GST3Data, setGST3Data] = React.useState(null);

  const [GSTReconciliation, setGSTReconciliation] = useState(false);

  const [openFilterDate, setOpenFilterDate] = React.useState(false);

  const [documnetType, setDocumentType] = React.useState(null);

  const handleClickOpenDate = (type) => {
    setDocumentType(type);
    setOpenFilterDate(true);
  };

  const handleCloseDate = () => {
    setDocumentType(null);
    setOpenFilterDate(false);
  };

  useEffect(() => {
    const session = Cookies.get("gstSession");
    if (!session) {
      navigate("/gst-login");
    }
  }, []);

  // ===========Alerts===================//
  const [alerts, setAlerts] = useState({
    visible: false,
    alertMessage: "",
    alertType: "",
  });

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  // Function to show success alert bar
  const successAlert = (message) => {
    setAlerts({
      visible: true,
      alertMessage: message || "Data fetched successfully.",
      alertType: "success",
    });
  };

  // Function to show error alert bar
  const errorAlert = (message) => {
    setAlerts({
      visible: true,
      alertMessage: message || "Something went wrong",
      alertType: "error",
    });
  };

  const toggleDrawer = (anchor, open) => (event) => {
    setState({ ...state, [anchor]: open });
  };

  // Function to close alert bar
  const closeAlertBar = () => setAlerts({ ...alerts, visible: false });

  const handleDelete = (ele) => {
    userConfig.hideColumn(window.location.pathname, currentTable, ele.id);
    const getHeaderConfig = userConfig.getHeader(
      window.location.pathname,
      currentTable
    );
    setHeaderConfig(getHeaderConfig);
  };

  const columnHandle = (val) => {
    if (val !== null) {
      if (val?.alias === "all") {
        userConfig.showAllColumn(window.location.pathname, currentTable);
        setHeaderConfig(
          userConfig.getHeader(window.location.pathname, currentTable)
        );
        return;
      }
      if (val?.alias === "remove") {
        userConfig.hideAllColumn(window.location.pathname, currentTable);
        setHeaderConfig(
          userConfig.getHeader(window.location.pathname, currentTable)
        );
        return;
      }
      if (val?.id) {
        userConfig.showColumn(window.location.pathname, currentTable, val?.id);
        setHeaderConfig(
          userConfig.getHeader(window.location.pathname, currentTable)
        );
      }
    }
  };

  useEffect(() => {
    const currentPage = window.location.pathname;
    const getHeaderConfig = userConfig.getHeader(currentPage, currentTable);
    setHeaderConfig(getHeaderConfig);
  }, [currentTable]);

  const handleClickOpen = (event) => {
    setOpen(true);
  };

  const renderAutocomplete = (label, value, width) => (
    <Grid item>
      <TextField
        id="outlined-basic"
        label={label}
        variant="outlined"
        size="small"
        margin="dense"
        style={{ minWidth: width, maxWidth: 300 }}
        onChange={() => handleClickOpen(label)}
        value={
          value && value.length > 0
            ? value[0]?.name +
              (value.length > 1 ? " +" + (value.length - 1) : "")
            : ""
        }
        onClick={() => handleClickOpen(label)}
      />
    </Grid>
  );

  const handleToDate = (value, type) => {
    if (type === "date") {
      const fromDateCurrent = moment(fromDate);
      const toDateCurrent = moment(value);
      const result = toDateCurrent.diff(fromDateCurrent, "days");
      const alertMessage =
        result < 0 ? "To Date should be after From Date" : "";

      setAlerts({
        visible: result < 0,
        alertMessage,
        alertType: "error",
      });

      if (result >= 0) {
        setToDate(value);
      }
    }
  };

  const handleFromDate = (value, type) => {
    if (type === "date") {
      if (toDate != null) {
        const toDateCurrent = moment(toDate);
        const fromDateCurrent = moment(value);
        const result = toDateCurrent.diff(fromDateCurrent, "days");
        const alertMessage =
          result < 0 ? "From Date should be before To Date" : "";

        setAlerts({
          visible: result < 0,
          alertMessage,
          alertType: "error",
        });

        if (result >= 0) {
          setFromDate(value);
        }
      } else {
        setFromDate(value);
      }
    }
  };

  const filteredValues = [
    // {
    //   typeId: 3,
    //   label: "From Date",
    //   value: fromDate,
    //   style: { width: 200, margin: "0 15px" },
    //   function: (value) => handleFromDate(value, "date"),
    // },

    // {
    //   typeId: 3,
    //   label: "To Date",
    //   value: toDate,
    //   style: { width: 200, margin: "0 15px" },
    //   function: (value) => handleToDate(value, "date"),
    // },
    {
      typeId: 2,
      label: "Month",
      options: financialYearMonthList || [],
      value: selectedMonth,
      style: { width: 200, margin: "0 15px" },
      function: (event, newValue) => {
        setSelectedMonth(newValue);
        if (newValue) {
          setToDate(null);
          setFromDate(null);
        }
      },
      className: null,
      type: "name",
    },
    {
      typeId: 4,
      label: "Year",
      options: financialYearList || [],
      value: selectedYear,
      style: { width: 200, margin: "0 15px" },
      function: (event, newValue) => {
        setSelectedYear(newValue);
        if (newValue) {
          setToDate(null);
          setFromDate(null);
        }
      },
      className: null,
      type: "name",
    },
  ];

  // filter list send to other component --->> call
  const list = (anchor) => (
    <SideBar
      anchor={anchor}
      toDate={toDate}
      handleToDate={handleToDate}
      fromDate={fromDate}
      handleFromDate={handleFromDate}
      state={state}
      setState={setState}
      toggleDrawer={toggleDrawer}
      filteredValues={filteredValues}
      handleSubmitFilterValue={handleSubmitFilterValue}
      handleResetFilter={handleResetFilter}
    />
  );

  // handle filtered the data and call geTGSTReportsData api
  const handleSubmitFilterValue = () => {
    try {
      const sessionData = Cookies.get("gstSession");
      setState((prevState) => ({ ...prevState, right: false }));

      if (!sessionData) return;

      const parsedSessionData = JSON.parse(sessionData);

      if (parsedSessionData?.gstLogin) {
        getGSTReportsData({ sessionData: parsedSessionData.gstLogin });
      }
    } catch (error) {
      console.error("Error parsing GST session data:", error);
    }
  };

  // reset the filter data --->>> render the by default data
  const handleResetFilter = (isGetAcc) => {
    const filterValuesData =
      localStorage.getItem("filter") &&
      JSON.parse(localStorage.getItem("filter"));
    const currentLocation = window.location.pathname;
    if (filterValuesData) {
      const updatedFilterData = filterValuesData?.filter(
        (ele) => ele?.pathname !== currentLocation
      );
      localStorage.setItem("filter", JSON.stringify(updatedFilterData));
      setFromDate(null);
      setToDate(null);
      setState({ ...state, right: false });
    }
  };

  const iconTemplateArray = [
    {
      name: "Export Excel",
      isInputIcon: false,
      icon: <AiFillFileExcel color="#1d6f42" size={40} />,
      function: () => handleClickOpenDate("Excel"),
      style: {
        display: checkPermissionExist(endPoints, gstExportEndpoint)
          ? "inline-flex"
          : "none",
      },
    },
  ];

  const getGSTReportsData = async ({ sessionData }) => {
    setLoading(true);
    try {
      console.log(sessionData, "Session Data");

      const retPeriod = `${selectedMonth?.id || ""}${selectedYear?.name || ""}`;
      const encodedSessionData = encodeURIComponent(sessionData);

      let endpoint;
      switch (currentTable) {
        case "GSTR1ReportTable":
          endpoint = gstr1DataEndpoint;
          break;
        case "GSTR2ReportTable":
          endpoint = gstr2DataEndpoint;
          break;
        default:
          endpoint = gstr3BDataEndpoint;
      }

      const response = await userService.getData(
        `${endpoint}?gstAuthDataId=${encodedSessionData}&retPeriod=${retPeriod}`
      );

      if (response?.status === 200 && response?.data) {
        successAlert("Data fetched successfully!");

        if (currentTable === "GSTR3ReportTable") {
          const gstData = response?.data?.data || {};
          const transformedData = {
            gstin: gstData.gstin,
            taxPeriod: gstData.taxPeriod,
            outwardInwardSuppliesDetails: [
              {
                name: "Outward Taxable Supplies",
                ...gstData.outwardInwardSuppliesDetails?.outwardTaxableSupplies,
              },
              {
                name: "Zero Rated Supplies",
                ...gstData.outwardInwardSuppliesDetails?.zeroRatedSupplies,
              },
              {
                name: "Nil Rated Supplies",
                ...gstData.outwardInwardSuppliesDetails?.nilRatedSupplies,
              },
              {
                name: "Inward Supplies Reverse Charge",
                ...gstData.outwardInwardSuppliesDetails
                  ?.inwardSuppliesReverseCharge,
              },
              {
                name: "Non-GST Outward Supplies",
                ...gstData.outwardInwardSuppliesDetails?.nonGstOutwardSupplies,
              },
            ],
            itcEligibleDetails: [
              {
                name: "ITC Available",
                cess: 0,
                cgst: 0,
                igst: 0,
                sgst: 0,
                taxableValue: 0,
                childList: null,
              },
              {
                name: "impg",
                ...gstData.itcEligibleDetails?.itcAvailable?.impg,
              },
              {
                name: "ITC Reversed",
                cess: 0,
                cgst: 0,
                igst: 0,
                sgst: 0,
                taxableValue: 0,
                childList: null,
              },
              {
                name: "Net ITC Available",
                cess: 0,
                cgst: 0,
                igst: 0,
                sgst: 0,
                taxableValue: 0,
                childList: null,
              },
            ],
            taxPaidSummaryDetails: [
              {
                name: "Tax Paid Details",
                cess: 0,
                cgst: 0,
                igst: 0,
                sgst: 0,
                taxableValue: 0,
              },
              {
                name: "Interest Late Fee",
                ...gstData.taxPaidSummaryDetails?.interestLateFee,
              },
            ],
          };

          console.log(transformedData, "nnxdj");
          setGST3Data(transformedData);
        } else {
          setGSTData(response?.data?.data);
        }
      } else {
        errorAlert("Data fetch not successful!");
      }
    } catch (error) {
      console.error("Error fetching GST data:", error);
      errorAlert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    const sessionData = Cookies.get("gstSession");

    let parsedSessionData;
    try {
      parsedSessionData = sessionData ? JSON.parse(sessionData) : null;
    } catch (error) {
      console.error("Error parsing session data:", error);
      parsedSessionData = null;
    }

    if (parsedSessionData?.gstLogin) {
      getGSTReportsData({ sessionData: parsedSessionData.gstLogin });
    }
  }, [currentTable]);

  useEffect(() => {
    const filteredData =
      localStorage.getItem("filter") &&
      JSON.parse(localStorage.getItem("filter"));
    const currentLocation = window.location.pathname;
    if (filteredData) {
      const findCurrentFilter = filteredData.find(
        (ele) => ele.pathname === currentLocation
      );

      if (findCurrentFilter) {
        const filterValues = findCurrentFilter.value;
        setFromDate(
          filterValues.find((item) => item.label === "From Date")?.value || null
        );
        setToDate(
          filterValues.find((item) => item.label === "To Date")?.value || null
        );
        setSelectedMonth(
          filterValues.find((item) => item.label === "Month")?.value || null
        );
      }
    } else {
      setFromDate(null);
      setToDate(null);
      setSelectedMonth(financialYearMonth[currentMonthIndex]);
      setState({ ...state, right: false });
    }
  }, [restoredSite]);

  // found any data from it -->>>means search
  const localSearchHandle = () => {
    const sessionData = Cookies.get("gstSession");

    let parsedSessionData;
    try {
      parsedSessionData = sessionData ? JSON.parse(sessionData) : null;
    } catch (error) {
      console.error("Error parsing session data:", error);
      parsedSessionData = null;
    }

    if (parsedSessionData?.gstLogin) {
      getGSTReportsData({ sessionData: parsedSessionData.gstLogin });
    }
  };

  // filter the data through this component
  const renderDrawerButton = () => (
    <Grid item>
      <div>
        {["right"].map((anchor) => (
          <React.Fragment key={anchor}>
            {isFilterApplied ? (
              <Badge color="primary" variant="dot">
                <IconButton
                  style={{ background: "#c35151", color: "#fff" }}
                  onClick={toggleDrawer(anchor, true)}
                >
                  <TuneIcon />
                </IconButton>
              </Badge>
            ) : (
              <IconButton
                style={{ background: "#c35151", color: "#fff" }}
                onClick={toggleDrawer(anchor, true)}
              >
                <TuneIcon />
              </IconButton>
            )}
            <Drawer
              anchor={anchor}
              open={state[anchor]}
              onClose={toggleDrawer(anchor, false)}
            >
              {list(anchor)}
            </Drawer>
          </React.Fragment>
        ))}
      </div>
    </Grid>
  );
  const isFilterApplied = selectedMonth || selectedYear;

  // use search through enter key press
  const handleKeyPress = (e) => {
    const sessionData = Cookies.get("gstSession");
    let parsedSessionData;
    try {
      parsedSessionData = sessionData ? JSON.parse(sessionData) : null;
    } catch (error) {
      console.error("Error parsing session data:", error);
      parsedSessionData = null;
    }

    if (e.key === "Enter" && parsedSessionData?.gstLogin) {
      if (pageNo === 1) {
        getGSTReportsData({ sessionData: parsedSessionData.gstLogin });
      } else {
        setPageNo(1);
      }
    }
  };

  const exportReportsInPdf = async (type, fromDate, toDate) => {
    try {
      setLoading(true);

      if (!userService?.getData) {
        throw new Error("Service unavailable.");
      }

      // Ensure date format is "YYYY-MM-DD"
      const formattedFromDate = moment(fromDate).format("DD/MM/YYYY");
      const formattedToDate = moment(toDate).format("DD/MM/YYYY");

      const response = await userService.getData(
        `${gstExportEndpoint}?from=${formattedFromDate}&to=${formattedToDate}`
      );

      if (response?.data?.status === 200) {
        successAlert(response?.data?.message || "Data exported successfully!");
      } else {
        throw new Error(response?.data?.message || "Export Error");
      }
    } catch (error) {
      errorAlert(error.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const moveOnReconciliationPage = () => {
    if (!fromDate || !toDate) {
      errorAlert("Please select both From and To Date for Reconciliation.");
      return;
    }

    if (documnetType === "reconciliationProcess") {
      setGSTReconciliation(true);
      navigate("/gst/reconciliation-report", {
        state: {
          currentTable: currentTable,
          GSTReconciliation: GSTReconciliation,
          fromDate: fromDate,
          toDate: toDate,
        },
      });
    } else if (documnetType === "Excel") {
      exportReportsInPdf(documnetType, fromDate, toDate);
    }
    setOpenFilterDate(false);
  };

  return (
    <>
      <Paper
        className={classes.paper}
        elevation={0}
        style={{ width: "100%", overflow: "auto" }}
      >
        <FilteredDate
          open={openFilterDate}
          setOpen={setOpenFilterDate}
          handleClickOpen={handleClickOpenDate}
          handleClose={handleCloseDate}
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
          moveOnReconciliationPage={moveOnReconciliationPage}
          themecolor={themecolor}
          documnetType={DocumentType}
          setDocumentType={setDocumentType}
        />
        <Container style={{ maxWidth: "100%" }}>
          <Grid container style={{ margin: "0", alignItems: "center" }}>
            <Header
              gridSize="3"
              source={GSTReportsIcon}
              headerText={
                GSTReconciliation
                  ? "GST Reconciliation"
                  : window.location.pathname === "/gst/gst-1"
                  ? "GSTR-1 Report"
                  : window.location.pathname === "/gst/gst-2"
                  ? "GSTR-2 Report"
                  : "GSTR-3B Report"
              }
            />

            <Grid
              item
              xs={9}
              container
              alignItems="center"
              justifyContent="flex-end"
              spacing={1}
            >
              {/* {GSTReconciliation && ( */}
              <Grid item>
                <Button
                  variant="contained"
                  style={{
                    background: themecolor,
                    color: "#fff",
                    marginRight: "10px",
                  }}
                  onClick={() => navigate("/gst/gst-details-portal")}
                >
                  GST Menu
                </Button>
              </Grid>
              {/* )} */}
              {!GSTReconciliation && currentTable !== "GSTR3ReportTable" && (
                <>
                  <Grid item>
                    <Button
                      variant="contained"
                      style={{
                        background: themecolor,
                        color: "#fff",
                        marginRight: "10px",
                      }}
                      onClick={() =>
                        handleClickOpenDate("reconciliationProcess")
                      }
                    >
                      Reconciliation
                    </Button>
                  </Grid>
                  {renderAutocomplete(
                    "Columns",
                    (headerConfig || [])?.filter(
                      (ele) => ele.name !== "S.NO" && ele.isShow !== false
                    ) || [],
                    "20px"
                  )}
                  {
                    <AutoDialogBox
                      columnHandle={columnHandle}
                      handleDelete={handleDelete}
                      open={open}
                      setOpen={setOpen}
                      setScroll={"paper"}
                      // scroll={scroll}
                      scroll={"paper"}
                      columns={(headerConfig || [])?.filter(
                        (ele) => ele.name !== "S.NO"
                      )}
                      heading={"Columns"}
                      autoCompName={"Columns"}
                    />
                  }
                </>
              )}

              {/* <Grid item>
                <TextField
                  value={searchField}
                  onChange={(e) => setSearchField(e.target.value)}
                  margin="dense"
                  size="small"
                  style={{
                    maxWidth: 250,
                  }}
                  label="Search"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={localSearchHandle}
                        >
                          <FcSearch />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  onKeyPress={(e) => handleKeyPress(e)}
                />
              </Grid> */}
              <Grid item>
                {iconTemplateArray?.length > 0 && (
                  <IconTemplate data={iconTemplateArray} />
                )}
              </Grid>
              {!GSTReconciliation && renderDrawerButton()}
            </Grid>
          </Grid>
          {/* {GSTReconciliation ? (
            <Reconciliation12
              currentTable={currentTable}
              GSTReconciliation={GSTReconciliation}
              pageNo={pageNo}
              setPageNo={setPageNo}
              totalPages={totalPages}
              setTotalPages={setTotalPages}
              pageSize={pageSize}
              setPageSize={setPageSize}
              fromDate={fromDate}
              toDate={toDate}
              navigate={navigate}
            />
            <></>
          ) : */}
          {currentTable === "GSTR3ReportTable" && GST3Data ? (
            <>
              {[
                {
                  heading: "Details of Outward and Inward Supplies",
                  data: GST3Data?.outwardInwardSuppliesDetails || [],
                },
                {
                  heading: "Eligible Input Tax Credit (ITC)",
                  data: GST3Data?.itcEligibleDetails || [],
                },
                {
                  heading: "Details of Tax Paid",
                  data: GST3Data?.taxPaidSummaryDetails || [],
                },
              ].map((item, index) => (
                <GST3Report
                  key={index}
                  heading={item.heading}
                  headerConfig={headerConfig}
                  data={item.data}
                  pageNo={pageNo}
                  setPageNo={setPageNo}
                  totalPages={totalPages}
                  setTotalPages={setTotalPages}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                />
              ))}
            </>
          ) : (
            <GSTTable
              headerConfig={headerConfig}
              data={GSTData || []}
              pageNo={pageNo}
              setPageNo={setPageNo}
              totalPages={totalPages}
              setTotalPages={setTotalPages}
              pageSize={pageSize}
              setPageSize={setPageSize}
            />
          )}
        </Container>
        {loading && <LoadingComponent />}
        {/* ==============Alerts=============== */}
        <AlertBar
          visible={alerts?.visible}
          closeAlertBar={closeAlertBar}
          alertMessage={alerts?.alertMessage}
          alertType={alerts?.alertType}
        />
      </Paper>
    </>
  );
};

export default withStyles(styles)(Index);
